import type { UnassignedPaddock } from '@/types/apiModels'

// LP and TEMPLATE are non-year subdivision buckets that never require data collection.
const isCalendarYear = (year: string): boolean => /^\d{4}$/.test(year)

export const groupUnassignedByCalendarYear = (
  items: UnassignedPaddock[],
): Record<string, UnassignedPaddock[]> => {
  return items.reduce<Record<string, UnassignedPaddock[]>>((acc, item) => {
    const { year } = item
    if (!isCalendarYear(year)) {
      return acc
    }
    if (!acc[year]) {
      acc[year] = []
    }
    acc[year].push(item)
    return acc
  }, {})
}
